import { render, staticRenderFns } from "./InterWalletRechargeDeduction.vue?vue&type=template&id=34823ef8"
import script from "./InterWalletRechargeDeduction.vue?vue&type=script&lang=js"
export * from "./InterWalletRechargeDeduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports